import getApiCore from './../core'

const withdrawsPath = (fscClientId: string, accountNumber: string) =>
  `v1/withdrawal/${fscClientId}/financial-account/${accountNumber}`

type WithdrawPostBodyBankAccount = {
  name: string
  bankNumber: string
  branchNumber: string
  accountNumber: string
  accountSuffix: string
}

export enum WithdrawalTypeEnum {
  Full = 'Full',
  Partial = 'Partial',
  Partial_Custom_Dollars = 'Partial (Custom $)',
}

type WithdrawPostBodyCommon = {
  type: WithdrawalTypeEnum
  useBankAccountOnFile: boolean
  newBankAccount: WithdrawPostBodyBankAccount | null
}
type WithdrawPostBodyFull = {}
type WithdrawPostBodyPartial = {
  totalWithdrawalAmount: number
}
type WithdrawPostBodyCustomDollars = {
  customAllocations: {
    amount: number
    fundCode: string
  }[]
}

export type WithdrawPostBody = WithdrawPostBodyCommon &
  (
    | WithdrawPostBodyFull
    | WithdrawPostBodyPartial
    | WithdrawPostBodyCustomDollars
  )

type PostWithdrawParams = {
  fscClientId: string
  accountNumber: string
  data: WithdrawPostBody
}

export default function getWithdrawApi(authToken: string) {
  const apiCore = getApiCore(authToken)

  return {
    postWithdraw: (params: PostWithdrawParams) =>
      apiCore.post(withdrawsPath(params.fscClientId, params.accountNumber), {
        data: {
          ...params.data,
          source: 'FFO Web',
        },
      }),
  }
}

export const getBankAccountDetails = (bankAccountNumber?: string) => {
  if (!bankAccountNumber) {
    return null
  }

  const [
    bankNumber,
    branchNumber,
    accountNumber,
    accountSuffix,
  ] = bankAccountNumber.split('-')
  return {
    bankNumber,
    branchNumber,
    accountNumber,
    accountSuffix,
  }
}
